import { RouteObject } from "react-router";

import { convertRouteModule } from "../../../lib/routing";

export const utilizationRoutes: Array<RouteObject> = [
  {
    id: "utilization",
    path: "*",
    lazy: async () => convertRouteModule(await import("./utilization")),
    children: [
      {
        lazy: async () => convertRouteModule(await import("./application")),
        children: [
          { index: true, element: null },
          {
            path: "configure",
            lazy: async () => convertRouteModule(await import("./configure-aspect")),
          },
        ],
      },
    ],
  },
];
